import React, { useCallback } from 'react';

import { Filter2, IFilterAvailableProps } from '../../../new_filter/Filter2';
import { NumberInputRange } from '../../../common/NewNumberInputRange/NumberInputRange';
import { HouseAreaFilter } from '../../../../models/Filter';
import { INumberRange } from '../../../../types/IRange';

interface IDesktopHouseAreaFilterProps extends IFilterAvailableProps {
    filter: HouseAreaFilter;
    handleChange: (value: HouseAreaFilter) => void;
}

export const DesktopHouseAreaFilterView: React.FC<IDesktopHouseAreaFilterProps> = ({
    filter,
    handleChange,
    withoutTitle
}) => {
    const handleAreaChange = useCallback((value: INumberRange) => {
        handleChange(new HouseAreaFilter(value));
    }, [ handleChange ]);

    return (
        <Filter2 filterTitle={withoutTitle ? undefined : 'Площадь дома'}>
            <NumberInputRange
                nameFrom='house-area-from'
                nameTo='house-area-to'
                size='s'
                unit='м²'
                fromPostfix='м²'
                value={filter.value}
                onChange={handleAreaChange}
                max={100_000}
            />
        </Filter2>
    );
};
